import { render, staticRenderFns } from "./DataTableTopBar.vue?vue&type=template&id=8a50cdd6&scoped=true&"
import script from "./DataTableTopBar.vue?vue&type=script&lang=js&"
export * from "./DataTableTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a50cdd6",
  null
  
)

export default component.exports